import React from "react";

function Commnet({ data }) {
    console.log(data.link);
    React.useEffect(() => {
        if (window.FB) {
            window.FB.XFBML.parse();
        }
    }, [data]);
    return (
        <>
            <div
                className="fb-like"
                data-href={`https://vutrusieuxe.netlify.app${data.link}`}
                data-width="80"
                data-layout="button_count"
                data-action="like"
                data-size="small"
                data-share="true"
            ></div>
            <div
                className="fb-comments"
                data-href={`https://vutrusieuxe.netlify.app${data.link}`}
                data-width="100%"
                data-numposts="5"
                data-lazy="true"
            ></div>
        </>
    );
}

export default Commnet;
